import React, {useEffect, useState} from 'react';
import {useController, useForm} from "react-hook-form";
import moment from "moment/moment";
import {Helmet} from "react-helmet";
import {Portlet, PortletBody, PortletHeader, PortletHeaderToolbar} from "../../../../components/Portlet";
import CustomDatePicker from "../../../base/components/forms/customDatePicker";
import ApiSelect from "../../../base/components/forms/apiSelect";
import _ from "lodash";
import {Col} from "react-bootstrap";
import LoadingButton from "../../../base/components/loadingButton";
import axios from "../../../../helpers/axios";
import RegistersReviceTabs from "../../components/registersReviceTabs";
import BlockUi from "@availity/block-ui";
import SearchSelect from "../../../../components/searchSelect";
import {useLocation} from "react-router-dom";
import numberFormat from "../../../../helpers/numberFormat";
import PaintedButton from "../../components/paintedButton";
import PaitedServButton from "../../components/paitedServButton";

const ReviseGroupPage = ({options}) => {
  const [loading, setLoading] = useState(false)
  const [data, setData] = useState()
  const { search } = useLocation();
  const params = new URLSearchParams(search)
  const [groups, setGroups] = useState()
  const defaultValues = options ? options : {
    startDate:moment().subtract(7, 'days').format('DD.MM.YYYY'),
    endDate: moment().format('DD.MM.YYYY')}
  const formController = useForm({defaultValues})
  const {control,
    setValue,
    getValues,
    formState:{errors},
    handleSubmit} = formController

  const {
    field: { onChange: counterpartyOnChange, value: counterpartyValue }
  } = useController({
    name: `id`,
    control,
    rules: { required: true },
    defaultValue: ''
  });
  const onSubmit = (data) =>{
    console.log('data', data)
    setLoading(true)
    axios.post('/api/racoon/revise/group/check/'+data.id, data)
      .then(({data})=>{
        setData(data)
      })
      .finally(()=>{
        setLoading(false)
        window.history.pushState({}, null, `/racoon/group/edit/${data.id}?start=${data.startDate}&end=${data.endDate}&id=${data.id}#racoon`)
      })
  }

  useEffect(() => {
    axios.post('/api/racoon/revise/group/searchInput')
      .then(({data})=>{
        setGroups(data.data)
      })
    options && onSubmit(options)
  }, []);

  useEffect(() => {
    if(search){
      onSubmit({
        startDate: params.get('start'),
        endDate: params.get('end'),
        id: params.get('id'),
      })
      setValue('startDate', params.get('start'))
      setValue('endDate', params.get('end'))
      setValue('id', params.get('id'))
      // window.history.pushState({}, null, '/racoon/group/revise')
    }
  }, []);


  return (
    <>
      <Helmet><title>Сверка по группам</title></Helmet>
      <BlockUi blocking={loading}>
        <Portlet>
          <PortletHeader title={data ?
            <div className={'d-flex align-items-center gap-2'}>
              Сумма реестра: {numberFormat(data.group.approximateSumm)}
              <PaintedButton data={data}/>
              <PaitedServButton/>
            </div>
            :'Сверка по группам'} toolbar={<PortletHeaderToolbar>
            {groups && <form onSubmit={handleSubmit(onSubmit)} className={'d-flex gap-2 align-items-center'}>
              <CustomDatePicker formController={formController}
                                label={"Дата c"}
                                value={getValues().startDate}
                                name={`startDate`}
                                cb={(date)=>{
                                  console.log(date)
                                  params.set('startDate',moment(date).format('DD.MM.YYYY'))
                                }}
                                rules={{required: true}}/>
              <CustomDatePicker formController={formController}
                                label={"Дата по"}
                                value={getValues().endDate}
                                name={`endDate`}
                                rules={{required: true}}/>
              <div style={{width: 200}}>
                <SearchSelect
                  onChange={(v) => {
                    counterpartyOnChange(v)
                    const group = _.find(groups, {value: v})
                    setValue('startDate', group.startDate)
                    setValue('endDate', group.endDate)
                    console.log(v)
                  }}
                  defaultValue={counterpartyValue}
                  label={'Группа'}
                  unregister
                  array={groups}/>
              </div>
              <LoadingButton loading={loading} title={'Получить'}/>
            </form>}
          </PortletHeaderToolbar>}/>
          <PortletBody className={'pt-1'}>
            {data && <RegistersReviceTabs info={data} onReload={() => onSubmit(getValues())}/>}
          </PortletBody>
        </Portlet>
      </BlockUi>
    </>
  );
};

export default ReviseGroupPage;
